import { Pipe, PipeTransform } from '@angular/core';
import { ApiMessageService } from '@lockton-apps/shared/util/api-message';
import { Translation } from '@lockton-apps/shared/interfaces';

@Pipe({
  name: 'apiMessage',
  standalone: true,
})
export class ApiMessagePipe implements PipeTransform {
  constructor(private readonly apiMessageService: ApiMessageService) {}

  transform(translation: Translation): string {
    return this.apiMessageService.translate(translation);
  }
}
